export function useHtmlEscaper() {
  const stripTags = (str: string) => {
    const domParser = new DOMParser().parseFromString(str, 'text/html');
    return domParser.body.textContent || '';
  };

  return { stripTags };
}
